import Customer from "models/Customer";
import Survey from "models/Survey";

export const SET = "customerList/SET";
export const CHANGE_SEARCH_FORM = "customerList/CHANGE_SEARCH_FORM";
export const CHANGE_PAGE = "customerList/CHANGE_PAGE";
export const BREAK_CUSTOMER_LIST = "customerList/BREAK_CUSTOMER_LIST";

// Action
export const setCustomerList = res => ({
  type: SET,
  customers: res.customers,
  allLocales: res.locales,
  industries: res.industries,
  totalCount: res.totalCount,
  perPage: res.perPage
});

export const changeSearchForm = (key, value) => ({
  type: CHANGE_SEARCH_FORM,
  key,
  value
});

export const changePage = page => ({
  type: CHANGE_PAGE,
  page
});

export const breakCustomerList = () => ({
  type: BREAK_CUSTOMER_LIST
});

// Reducer
const initialState = {
  customers: [],
  search: {
    customerKey: "",
    customerName: "",
    industryId: "",
    industryParentId: "",
    enterpriseScale: "",
    showOnlyOpeningSurveyCustomer: false,
    memo: ""
  },
  page: 1,
  totalCount: 0,
  perPage: 0,
  allLocales: [],
  industries: {
    large: [],
    middle: []
  }
};

const customerList = (state = initialState, action) => {
  switch (action.type) {
    case SET: {
      const { allLocales, industries, totalCount, perPage } = action;
      const customers = action.customers.map(customer =>
        new Customer()
          .merge(customer)
          .set(
            "latestSurvey",
            customer.latestSurvey && new Survey(customer.latestSurvey)
          )
      );

      return {
        ...state,
        customers,
        allLocales,
        industries,
        totalCount,
        perPage
      };
    }

    case CHANGE_SEARCH_FORM: {
      const { key, value } = action;
      const search = { ...state.search, [key]: value };
      return { ...state, search };
    }

    case CHANGE_PAGE: {
      return { ...state, page: action.page };
    }

    case BREAK_CUSTOMER_LIST: {
      return initialState;
    }

    default:
      return state;
  }
};

export default customerList;



// WEBPACK FOOTER //
// ./src/redux/modules/customerList.js